<template>
    <div class="container-fluid container-wrap col-sm-12 col-xs-12">
        <div class="row justify-content-center">
            <div class="col-sm-12 col-xs-12">
                <div class=" pb-0 col-sm-12 d-flex mainDiv">
                    <div class="col-sm-12 col-xs-12">
                        <!-- 제조사 선택 UI (companyName 쿼리 없을 때) -->
                        <template v-if="!$route.query.companyName">
                            <div class="col-sm-12 col-xs-12 titleDiv CertListTitle justify-content-between title-area">
                                <div>
                                    <h3>제품 관리</h3>
                                    <h5>미제휴 제조사의 제품을 관리할 수 있습니다. 제조사를 선택해 주세요.</h5>
                                </div>
                            </div>
                            <div class="manufacturer-select-area">
                                <a-select
                                    v-model:value="selectedCompanyName"
                                    show-search
                                    placeholder="제조사를 선택하세요"
                                    style="width: 400px;"
                                    :filter-option="filterManufacturerOption"
                                    @change="handleManufacturerSelect"
                                >
                                    <a-select-option
                                        v-for="manufacturer in manufacturerList"
                                        :key="manufacturer._id"
                                        :value="manufacturer.companyName"
                                    >
                                        {{ manufacturer.companyName }}
                                    </a-select-option>
                                </a-select>
                            </div>
                        </template>

                        <!-- 기존 제품 관리 UI (companyName 쿼리 있을 때) -->
                        <template v-else>
                        <div class="col-sm-12 col-xs-12 titleDiv CertListTitle justify-content-between title-area" >
                            <div>
                                <h3>제품 관리</h3>
                                <h5>인증서를 발행할 제품을 관리할 수 있습니다.</h5>
                            </div>
                            <div class="d-flex gap-2">
                                <a-button
                                    type="primary"
                                    @click="uploadBulkFile"
                                >
                                    <i class="fa-regular fa-plus" />
                                    제품 대량 등록
                                </a-button>
                                <a-button
                                    type="primary"
                                    @click="downloadBulkExample"
                                >
                                    <i class="fa-solid fa-down-to-bracket" />
                                    제품 대량 등록 양식 다운로드(.xlsx)
                                </a-button>
                                <a-button
                                    type="primary"
                                    @click="openModal(modalType.create)"
                                >
                                    <i class="fa-regular fa-plus" />
                                    개별 등록
                                </a-button>
                                <input
                                    type="file"
                                    ref="bulkFileInput"
                                    style="width: 0; height: 0; display: none;"
                                />
                            </div>
                        </div>
                        <div class="card-body px-0 pt-0 pb-2 table-with-search">
                            <div class="col-xs-12 table-info-filter">
                                <div class="total-div">
                                    <p>
                                        전체 <span class="number-highlight">{{ formatCommaNumber(listSize) }}</span>건
                                    </p>
                                </div>
                                <div class="search-container">
                                    <a-select
                                        style="width: 150px"
                                        v-model:value="rowsPerPage"
                                        @change="handleRowsPerPage"
                                    >
                                        <a-select-option :value="10">10개씩 보기</a-select-option>
                                        <a-select-option :value="20">20개씩 보기</a-select-option>
                                        <a-select-option :value="50">50개씩 보기</a-select-option>
                                    </a-select>
                                    <div class="search-div">
                                        <a-select
                                            v-model:value="searchFilter"
                                            id="searchFilter"
                                            style="width: 100px;"
                                            class="no-radius-right"
                                        >
                                            <a-select-option value="" selected>
                                                선택
                                            </a-select-option>
                                            <a-select-option value="itemName">
                                                품목명
                                            </a-select-option>
                                            <a-select-option value="productCode">
                                                제품코드
                                            </a-select-option>
                                        </a-select>
                                        <div class="typing-area">
                                            <a-input
                                                placeholder="품목명 또는 제품코드를 입력하세요."
                                                v-model:value="condition"
                                                @keyup.enter="enter"
                                                class="no-radius-all"
                                                style="height: 100%; width: 250px;"
                                            />
                                            <a-button
                                                style="height: 100%;"
                                                @click="enter"
                                                class="black no-radius-left"
                                            >
                                                검색
                                            </a-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <a-table class="ant-table-striped"
                                size="small"
                                :columns="columns"
                                :data-source="responseData"
                                :pagination="false"
                            >
                                    <template #emptyText>
                                        <div class="noData">
                                            <i class="fa-solid fa-exclamation-triangle" style="font-size: 24px; margin-bottom: 10px"/><br>
                                            <span>{{computedNoResultMessage}}</span>
                                        </div>
                                    </template>
                                    <template #bodyCell="{ column, record }">
                                    </template>
                            </a-table>
                        </div>
                        <pagination
                            v-if="!$store.state.isLoading && responseData.length > 0"
                            :page-info="paginationData"
                            page-name="ProductList"

                            @change-page="paginationHandler"
                        />
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <ProductDetailM
            :id="modal.targetId"
            :show-modal="modal.modify.show"
            @close-modal="closeModal(modalType.modify)"
            @getProductsList="getProductsList"
        />
        <ProductDetailW
            :show-modal="modal.create.show"
            @close-modal="closeModal(modalType.create)"
            @getProductsList="getProductsList"
        />
        <ProductDetailR
            :id="modal.targetId"
            :show-modal="modal.read.show"
            @close-modal="closeModal(modalType.read)"
        />
    </div>
</template>

<script>
    import ProductDetailM from './components/ProductDetailM.vue';
    import ProductDetailW from './components/ProductDetailW.vue';
    import ProductDetailR from './components/ProductDetailR.vue';
    import NoResult from '@/views/components/NoResult.vue';
    import Pagination from '@/views/components/Pagination.vue';
    import { convertDate, oneBtnDialog, confirmDialog, changeBytesToKilos, formatCommaNumber,  } from '@/utils/utils';
    import { enums } from '@/utils/enums';
    import { modalType } from './enums/enums';
    export default {
        name: 'ProductsList',
        components: {
            ProductDetailM,
            ProductDetailW,
            ProductDetailR,
            NoResult,
            Pagination,
        },
        computed: {
            computedNoResultMessage() {
                if(this.calledApiTimes <= 1) {
                    return '아직 등록된 제품이 없습니다.';
                } else {
                    return '검색 결과가 없습니다.';
                }
            },
        },
        data() {
            return {
                modalType,
                formatCommaNumber,
                isInputFocused: false,
                manufacturerList: [],
                selectedCompanyName: undefined,
                // 타입
                type: 'HOSPITAL',
                // 목록 받아오는 변수
                responseData: [],

                // 페이지네이션 관련 변수
                searchFilter: '',
                condition: '',
                calledApiTimes: 0,
                modal: {
                    targetId: '',
                    read: {show: false,},
                    modify: {show: false,},
                    create: {show: false,},
                },
                selectedProduct: '',
                productDetailData: {},
                columns:[
                    {
                        key: 'index', title: '번호', dataIndex: 'index', align: 'center', width: "4%",
                    },
                    {
                        key: 'productType', title: '제품분류', dataIndex: 'productType', align: 'start',
                    },
                    {
                        key: 'itemName', title: '품목명', dataIndex: 'itemName', align: 'start',
                    },
                    {
                        key: 'productCode', title: '제품코드', dataIndex: 'productCode', align: 'start',
                    },
                    {
                        key: 'itemNo', title: '중복 발행', dataIndex: 'itemNo', align: 'start',
                            customRender: ({text, record}) => {
                                return record.itemNo === 0 ? '-' : record.itemNo
                            },
                    },
                    {
                        key: 'warrantyStatus', title: '인증서 상태', dataIndex: 'warrantyStatus', align: 'center',
                            customRender: ({text, record}) => {
                                return (
                                    <div className="status-wrap-align">
                                        <div className={`status-wrap ${record.warrantyStatus}`}>
                                        <span className="required-span"/>
                                        {this.convertCodeToText(record.warrantyStatus)}
                                        </div>
                                    </div>
                                )
                            },
                    },
                    {
                        key: 'createAt', title: '등록 일자', dataIndex: 'createAt', align: 'start',
                            customRender: ({text, record}) => {
                                return convertDate(record.createAt)
                            },
                    },
                    {
                        key: 'surgeryInfo', title: '수술/시술 일자', dataIndex: 'surgeryInfo', align: 'center',
                            customRender: ({text, record}) => {
                                if(record.surgeryInfo) return convertDate(record.surgeryInfo.surgeryAt);
                                return '-';
                            },
                    },
                    {
                        key: 'hospitalName', title: '병원', dataIndex: 'hospitalName', align: 'center',
                    },
                    {
                        key: 'detail-button', title: '상세', dataIndex: 'detail-button', align: 'center',
                        customRender: ({text, record}) => {
                            // @click="openModal(modalType.create)"
                            return (
                                <div
                                    style="width: 100%; justify-content: center; display: flex;"
                                >
                                    <a-button 
                                        shape="circle" 
                                        onClick={() => this.openModal(modalType.read, record._id)}
                                        icon={<i class="fa-light fa-ellipsis"/>}
                                    />
                                </div>
                            )
                        },
                    },
                    {
                        key: 'modify-button', title: '수정', dataIndex: 'modify-button', align: 'center',
                        customRender: ({text, record}) => {
                            if(record.warrantyStatus === enums().WarrantyStatusEnum.DISPOSED) {
                                return '';
                            }
                            return (
                                <div
                                    style="width: 100%; justify-content: center; display: flex;"
                                >
                                    <a-button 
                                        shape="circle" 
                                        onClick={() => this.openModal(modalType.modify, record._id)}
                                        icon={<i class="fa-regular fa-pen-to-square"/>}
                                    />
                                </div>
                            )
                        },
                    },
                    {
                        key: 'dispose-button', title: '폐기', dataIndex: 'dispose-button', align: 'center',
                        customRender: ({text, record}) => {
                            if(record.warrantyStatus === enums().WarrantyStatusEnum.DISPOSED) {
                                return '';
                            }
                            return (
                            <div
                                    style="width: 100%; justify-content: center; display: flex;"
                                >
                                    {record.warrantyStatus !== 'dispose' && (
                                        <a-button 
                                        shape="circle"
                                        onClick={() => this.deleteProduct(record._id)} 
                                        icon={<i className="fa-solid fa-trash-can"/>}
                                        />
                                    )}
                                    {record.warrantyStatus === 'dispose' && (
                                        <a-button 
                                        shape="circle"
                                        onClick={() => this.restoreProduct(record._id)}
                                        icon={<i className="fa-sharp fa-solid fa-rotate-left"/>}
                                        />
                                    )}
                                    </div>
                            )
                        },
                    },
                ],

                listSize: 0,
                rowsPerPage: 10, 
                paginationData: {
                    currentPage: 1, 
                    totalPages: 0,
                },
            };
        },
        watch: {
            async '$route'(to, from) {
                if(to.name == 'ProductsList'){
                    if (!to.query.companyName) {
                        await this.getManufacturerList();
                        return;
                    }
                    const obj = {};
                    obj.page = this.paginationData.currentPage;
                    this.paginationHandler(obj);
                }
            }
        },
        async mounted() {
            if (!this.$route.query.companyName) {
                await this.getManufacturerList();
                return;
            }
            const obj = {};
            obj.page = this.paginationData.currentPage;
            this.paginationHandler(obj);
        },
        
        methods: {
            convertDate,
            async getManufacturerList() {
                try {
                    const response = await this.$apiInstance.post(`/companies/certi-admin/unaffiliated-manufacturers`, { page: 1, limit: 9999 });
                    if (response.status === 200 || response.status === 201) {
                        this.manufacturerList = response.data.docs || response.data || [];
                    }
                } catch (error) {
                    console.log(error);
                    await oneBtnDialog('제조사 목록 로드 실패', '제조사 목록 로드에 실패하였습니다.', false);
                }
            },
            filterManufacturerOption(input, option) {
                return option.children?.[0]?.children?.toLowerCase().includes(input.toLowerCase())
                    || option.value?.toLowerCase().includes(input.toLowerCase());
            },
            handleManufacturerSelect(companyName) {
                this.$router.push(`/product-list?companyName=${encodeURIComponent(companyName)}`);
            },
            async closeModal(type, value) {
                this.modal[type].show = value;
            },
            async openModal(type, id) {
                if(id) this.modal.targetId = id;
                this.modal[type].show = true;
            },
            // 주요 API
            async paginationHandler(childPassParam) {
                this.paginationData.currentPage = childPassParam.page;
                await this.getProductsList();
            },
            // 전체 목록 가져오기
            async getProductsList() {
                const params = {};
                params.companyName = this.$route.query.companyName;
                params.page = this.paginationData.currentPage;
                params.limit = this.rowsPerPage;
                if (this.searchFilter !== '' && this.condition !== '') {
                    params.search = this.searchFilter;
                    params.condition = this.condition;
                }
                try {
                    const response = await this.$apiInstance.get(`/products/by-company-name`, { params });
                    if (response.status === 200 || response.status === 201) {
                    this.calledApiTimes ++;
                    if(response.data.docs) {
                        this.responseData = response.data.docs;
                    } else {
                        this.responseData = [];
                    }
                    this.listSize = response.data.totalDocs;
                    for (let i = 0; i < this.responseData.length; i++) {
                        this.responseData[i].index = this.listSize - (this.paginationData.currentPage - 1) * this.rowsPerPage  - i;
                    }
                    this.paginationData.totalPages = response.data.totalPages;
                    }
                } catch (error) {
                    console.log(error);
                    oneBtnDialog('제품 목록 로드 실패', '제품 목록 로드에 실패하였습니다.', false);
                }
            },
            // 제품 상세
            async getProductDetail(productId) {
                try {
                    const response = await this.$apiInstance.get(`/products/${productId}`);
                    if (response.status === 200 || response.status === 201) {
                    this.productDetailData = response.data;
                    this.productDetailData.productId = productId;
                    if (response.data.jsonContents) {
                        this.productDetailData.jsonContents = JSON.parse(
                            response.data.jsonContents
                        );
                    }
                    }
                } catch (error) {
                    console.log(error);
                    oneBtnDialog('제품 정보 로드 실패', '제품 정보 로드에 실패하였습니다.', false);
                }
            },
            //제품 삭제
            async deleteProduct(productId) {
                this.selectedProduct = productId;
                try {
                    const confirmResult = await confirmDialog('제품 폐기', '제품을 폐기하시겠습니까?');
                    if (confirmResult) {
                    const response = await this.$apiInstance.put(`/products/dispose/${this.selectedProduct}`);
                    if (response.status === 200 || response.status === 201) {
                        await oneBtnDialog('제품 폐기 완료', '제품이 폐기 완료 되었습니다.', false);
                        await this.getProductsList();
                    } 
                    }
                } catch(error) {
                    console.log(error);
                    await oneBtnDialog('제품 폐기 실패', '제품 폐기에 실패하였습니다.', false);
                }
            },
            // 제품 복구
            async restoreProduct(productId) {
                this.selectedProduct = productId;
                const confirmResult = await confirmDialog('제품 복구', '제품을 복구하시겠습니까?');
                if(!confirmResult) return;

                try {
                    const response = await this.$apiInstance.put(`/products/restore/${this.selectedProduct}`);
                    if (response.status === 200 || response.status === 201) {
                        await oneBtnDialog(
                            '제품 복구 완료',
                            '제품이 복구 완료 되었습니다.',
                            false
                        );
                        await this.getProductsList();
                    } else {
                        await oneBtnDialog(
                            '제품 복구 실패',
                            '제품이 복구에 실패하였습니다.',
                            false
                        );
                    }
                } catch (error) {
                    console.log(error);
                    await oneBtnDialog('제품 복구 실패', '제품 정보 복구에 실패하였습니다.', false);
                }
            },
            async enter() {
                if (this.searchFilter === '') {
                    await oneBtnDialog('검색 필터 미선택', '검색 필터를 선택해 주세요.', false);
                } else {
                    this.paginationData.currentPage = 1;
                    this.getProductsList();
                }
            },
            async handleRowsPerPage() {
                this.paginationData.currentPage = 1;
                await this.getProductsList();
            },
            // 인증서 상태 코드 텍스트로 변환
            convertCodeToText(code) {
                switch (code) {
                    case 'original-unissued':
                    return '원본 미발행';
                    case 'original-issued':
                    return '원본 발행';
                    case 'customer-issued':
                    return '고객 발행';
                    case 'unlimited-issued':
                    return '무제한 발행';
                    case 'hospital-issued':
                    return '병원 발행';
                    case 'dispose':
                    return '폐기';
                    default:
                    return '-';
                }
            },
            async uploadBulkFile() {
                try {
                this.clickFileInput();

                const file = await new Promise(resolve => {
                    this.$refs.bulkFileInput.onchange = (event) => {
                    resolve(event.target.files[0]);
                    };
                });
                
                const isValid = this.validateFile(file);
                if (!isValid) return;

                const formData = new FormData();
                formData.append('file', file);
                
                const objectStorageUrl = await this.uploadExcelOnObjectStorage(formData);
                
                if(objectStorageUrl) {
                    const obj = {};
                    obj.url = objectStorageUrl;
                    obj.companyName = this.$route.query.companyName;
                    const response = await this.$apiInstance.post(`/products/import/excel/datas/by-company-name`, obj);
                    if(response.status === 200 || response.status === 201) {
                    await oneBtnDialog('제품 대량등록 성공', '제품 대량등록에 성공하였습니다.', true);
                    }
                }

                } catch (error) {
                    console.error("Error uploading the file:", error);
                    if(error.response && error.response.status === 400) {
                    await oneBtnDialog('존재하지 않는 품목', '존재하지 않는 품목입니다.', false);
                    } else {
                    await oneBtnDialog('제품 대량등록 실패', '제품 대량등록에 실패하였습니다.', false);
                    }
                }
            },
            clickFileInput() {
                if(this.$refs.bulkFileInput) this.$refs.bulkFileInput.click();
                },
                async uploadExcelOnObjectStorage(fileData) {
                try {
                    const response = await this.$apiInstance.post(`/object-storages/excel`, fileData);
                if (response.status === 200 || response.status === 201) {
                    return response.data.url;
                } else {
                    return '';
                }
                } catch(error) {
                    console.log(error);
                    await oneBtnDialog('엑셀 파일 업로드 실패', '엑셀 파일 업로드에 실패하였습니다.', false);
                    return '';
                }
            },
            validateFile(file) {
                let result = true;
                if(file) {
                    if(!file.name.endsWith('.xlsx')) {
                    alert('xlsx형식 파일만 첨부 가능합니다.');
                    result = false;
                    } else if(changeBytesToKilos(file.size) > 100) {
                    alert('파일 크기가 100MB를 초과합니다.');
                    result = false;
                    }
                } 
                return result;
                },
                async downloadBulkExample() {
                const year = new Date().getFullYear();
                const month = String(new Date().getMonth() + 1).padStart(2, '0');
                const day = String(new Date().getDate()).padStart(2, '0');

                const formattedDate = `${year}${month}${day}`;
                try {
                    const response = await this.$apiInstance.get(`/products/export/excel/form/new`, { responseType: 'blob'});

                    if (response.status === 200 || response.status === 201) {
                    const blob = new Blob([response.data], {
                        type: 'application/octet-stream',
                    });

                    const url = URL.createObjectURL(blob);

                    const downloadLink = document.createElement('a');
                    downloadLink.href = url;
                    downloadLink.download = `제품대량등록양식_${formattedDate}.xlsx`;
                    downloadLink.click();

                    URL.revokeObjectURL(url);
                    } else {
                    // Handle the error case
                    }
                } catch (error) {
                    console.error(error);
                    await oneBtnDialog('파일 다운로드 실패', '파일 다운로드에 실패하였습니다.', false);
                }
            },
        },
    };
</script>


<style lang="scss">

.ant-table-wrapper {
    overflow-x: auto;
    background-color: white;
}
@media screen and (max-width:767px) {
  //개별 등록
  #productDetailWriteModal{
    padding: 20px;
    .modal-div-wrap .modal-input-div{
      flex-direction: column;
      input,
      select,
      textarea{
        width: 100% !important;
      }
    }
    .modal-div-wrap .modal-input-div .label-wrap{
      width: 100%;
    }
  }
}
</style>
<style lang="scss" scoped>

.manufacturer-select-area {
    display: flex;
    align-items: center;
    padding: 40px 0;
}

.row {
    padding: 28px 28px 72px 28px !important;
}
.ant-btn-primary {
    background-color: #ffe414;
}
.ant-btn {
    color: #17191C;
    height: 40px;
    box-shadow: none !important;
    transition: ease-in-out 0.3s;
    padding: 13px 18px;
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: center;
    transition: ease-in-out 0.3s;
}
@media screen and (max-width:767px) {
  
  .search-container {
    gap: 8px !important;
    .search-div {
        flex-direction: row;
        gap: 0px;
        background-color: initial !important;
        select{
            width: 150px !important;
        }
        .typing-area{
            width: 100%;
            gap: 0;
        }
    }
  }

  // 제품관리 목록화면
  .container-fluid .row.justify-content-center{
    padding: 14px 14px 36px 14px !important;
  }
  .mainDiv{
    width: 100% !important;
  }
  .header-btn{
    margin-left: auto;
  }
  .CertListTitle {
      width: 100%;
    .d-flex.gap-2{
      width: 100%;
      flex-direction: column;
      button{
        width: 100%;
        word-break: keep-all;
        text-align: left;
      }
    }
  }
  .table-with-search .table-info-filter{
    flex-direction: column;
    align-items: flex-start;
    flex: none;
    justify-content: flex-start;
    height: 210px;
  }
  .table-with-search .search-container .search-div input,
  .table-with-search .search-container .search-div button{
    width: 60px !important;
    min-width: auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .table-with-search .search-container .search-div input{
    width: calc(100% - 60px)!important;
  }
  #searchFilter{
    display: flex;
    flex-wrap: row;
  }
   .table-with-search .search-container,
   .table-with-search .search-container .search-div,
   .table-with-search .search-container select{
    width: 100%;
    flex: none;
   }
}

@media screen and (min-width:768px) and (max-width:1023px){
  .header-btn{
    padding: 12px;
  }
  .table-with-search .table-info-filter{
    flex-direction: column;
    width: 100%;
    .total-div{
      margin-right: auto;
    }
    .search-container{
      width: 100%;
      flex-direction: row;
      .search-div{
        flex-direction: row;
        width: 100%;
        input{
          width: calc(100% - 80px) !important;
        }
        .search-btn{
          min-width: 80px;
        }
      }
    }
  }

}
</style>